// extracted by mini-css-extract-plugin
module.exports = {"syncButton":"syncButton_syncButton__qTdnu","button":"syncButton_button__1mVdR"};